/**
 * Minimal theme hook for Seitiate+.
 *
 * The CES codebase has a full ThemeProvider with 4 themes (default, foundry,
 * bricolage, light). Seitiate+ uses a single dark developer aesthetic — no
 * theme switching needed for v1. This stub provides the same hook API so
 * migrated components compile without changes.
 */

export type ThemeName = 'default' | 'light';

export interface ThemeContextValue {
  themeName: ThemeName | string;
  setTheme: (next: ThemeName) => void;
}

// Seitiate+ is always dark. The hook returns a static value.
export function useTheme(): ThemeContextValue {
  return {
    themeName: 'default',
    setTheme: () => {
      // no-op in Seitiate+ v1 — single theme
    },
  };
}
